import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { AppConfigurator } from './app.configurator';
import { LayoutService } from '../service/layout.service';
import { ImageModule } from 'primeng/image';
import { interval, Subject, Subscription, takeUntil } from 'rxjs';
import { UserService } from '../../services/user-service/user.service';

@Component({
    selector: 'app-topbar',
    standalone: true,
    imports: [RouterModule, CommonModule, StyleClassModule, AppConfigurator,ImageModule],
    template: ` <div class="layout-topbar">
        <div class="layout-topbar-logo-container">
            <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
                <i class="pi pi-bars"></i>
            </button>
            <a class="layout-topbar-logo" routerLink="/">
              <p-image *ngIf="!layoutService.isDarkTheme()" src="assets/images/light-mode_logo_SAT.png" alt="logo" width="200" height="100"></p-image>
              <p-image *ngIf="layoutService.isDarkTheme()" src="assets/images/dark-mode_logo_SAT.png" alt="logo" width="200" height="100"></p-image>
            </a>
        </div>

        <div class="layout-topbar-actions">
            <div class="layout-config-menu">
                <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
                    <i [ngClass]="{ 'pi ': true, 'pi-moon': layoutService.isDarkTheme(), 'pi-sun': !layoutService.isDarkTheme() }"></i>
                </button>
                <div class="relative">
                    <!--<button
                        class="layout-topbar-action layout-topbar-action-highlight"
                        pStyleClass="@next"
                        enterFromClass="hidden"
                        enterActiveClass="animate-scalein"
                        leaveToClass="hidden"
                        leaveActiveClass="animate-fadeout"
                        [hideOnOutsideClick]="true"
                    >
                        <i class="pi pi-palette"></i>
                    </button>-->
                    <app-configurator />
                </div>
            </div>

            <button class="layout-topbar-menu-button layout-topbar-action" pStyleClass="@next" enterFromClass="hidden" enterActiveClass="animate-scalein" leaveToClass="hidden" leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true">
                <i class="pi pi-ellipsis-v"></i>
            </button>

            <div class="layout-topbar-menu hidden lg:block">
                <div class="layout-topbar-menu-content flex items-center gap-2">
                    <!-- <button type="button" class="layout-topbar-action">
                        <i class="pi pi-calendar"></i>
                        <span>Calendar</span>
                    </button>
                    <button type="button" class="layout-topbar-action">
                        <i class="pi pi-inbox"></i>
                        <span>Messages</span>
                    </button> -->
                    <button type="button" class="layout-topbar-action flex items-center">
                        <i class="pi pi-user"></i>
                        <span>Profile</span>
                    </button>
                     <span styleClass="text-center justify-center text-sm font-weight">{{ current_user }}</span>
                </div>
            </div>
        </div>
    </div>`
})
export class AppTopbar {
    items!: MenuItem[];
    current_user: string = '';
    private destroy$ = new Subject<void>();

    constructor(public layoutService: LayoutService) {}
     ngOnInit() {
        this.updateUser();       
        // Vérifie le localStorage toutes les 500ms
        interval(500)
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.updateUser();
            });
    }

   ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    updateUser() {
        const user = JSON.parse(localStorage.getItem('currentUser') || '{}');
        const newUsername = user?.name || 'username';
        
        // Ne met à jour que si le nom a changé
        if (this.current_user !== newUsername) {
            this.current_user = newUsername;
        }
    }

    toggleDarkMode() {
        this.layoutService.layoutConfig.update((state) => ({ ...state, darkTheme: !state.darkTheme }));
    }
}
